export default __webpack_public_path__ + "static/media/paper_white.46f04892.svg";